import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import CoreStatus from "../../../../../app/core/components/CoreStatus/CoreStatus";
import IconButton from "@mui/material/IconButton";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { GESTIONE_PRATICHE_TABLE_HEADER } from "../../../../../utils/constants/tables";
import { formatItalianDate } from "../../../../../utils/functions/date-utils";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import SchedaUtente from "../../../../common/SchedaUtente/SchedaUtente";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress, Divider } from "@mui/material";
import CorePagination from "../../../../../app/core/components/CorePagination/CorePagination";
import { t } from "i18next";
import CoreIAicon from "../../../../../app/core/components/CoreIAicon/CoreIAicon";
import {
  useDoRemovePracticeMutation,
  useEditAdminPracticesMutation,
} from "../../../../api/admin/gestisciPraticheApi";
import { toast } from "react-toastify";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

const GestionePraticheTable = ({
  data,
  page,
  setPage,
  isLoading,
  orderDirection,
  setOrderDirection,
  valueToOrderBy,
  setValueToOrderBy,
  totalPages,
}) => {
  const navigate = useNavigate();
  const appConfig = useSelector((state) => state.app.appConfig);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const adminId = useSelector((state) => state.app.adminId);
  const practiceManagement = useSelector(
    (state) => state.practiceManagementSlice
  );

  const [isUserCardModalOpen, setIsUserCardModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");

  const [editAdmin] = useEditAdminPracticesMutation();
  const [removeAdmin] = useDoRemovePracticeMutation();

  const handleAdminPractices = (practice) => {
    const bodyEditAdmin = {
      adminId: adminId,
      practiceId: practice?.id,
    };
    editAdmin(bodyEditAdmin)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("PracticeNotTakenOn"));
          return;
        }
        toast.success(t("PracticeTakenOn"));
      })
      .catch(() => {
        toast.error(t("PracticeNotTakenOn"));
      });
  };

  const handleRemoveAdminPractices = (practice) => {
    removeAdmin(practice.id)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("PracticeRemoveNotTakenOn"));
          return;
        }
        toast.success(t("PracticeRemoveTakenOn"));
      })
      .catch(() => {
        toast.error(t("PracticeRemoveNotTakenOn"));
      });
  };

  const closeUserModal = () => {
    setIsUserCardModalOpen(false);
  };

  const handleOpenUserCard = (userId) => {
    setSelectedUserId(userId);
    setIsUserCardModalOpen(true);
  };

  const handleRequestSort = (property) => {
    if (property === "commercialista") {
      setValueToOrderBy("AdminId");
    } else {
      setValueToOrderBy(property);
    }
    const isAscending =
      (property === "commercialista"
        ? valueToOrderBy === "AdminId"
        : valueToOrderBy === property) && orderDirection === "asc";
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const isSelected = (id) =>
    practiceManagement.selectedPracticesIds.indexOf(id) !== -1;

  // Controllo parametrizzato (serviceWithLLM)
  const filteredItems = appConfig?.modules?.services?.prompt
    ? data?.items
    : data?.items?.filter((el) => el.aiPromptId === null);

  return (
    <div className="w-full  p-4">
      <TableContainer sx={{ position: "relative" }}>
        <Backdrop
          className="bg-black bg-opacity-30"
          sx={{ position: "absolute", zIndex: 1 }}
          open={isLoading}
        >
          <CircularProgress style={{ color: colorPrimary }} />
        </Backdrop>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size="medium"
        >
          <TableHead>
            <TableRow>
              {/* <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={isIndeterminate(
                    practiceManagement.selectedPracticesIds?.length,
                    filteredItems?.length
                  )}
                  checked={
                    practiceManagement.selectedPracticesIds?.length ===
                      filteredItems?.length && filteredItems?.length > 0
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all documents" }}
                />
              </TableCell> */}
              {GESTIONE_PRATICHE_TABLE_HEADER()
                .filter((column) => {
                  if (column.id === "company") {
                    return appConfig?.modules?.company?.general;
                  }
                  return true;
                })
                .map((column) => (
                  <TableCell
                    key={column.id}
                    align="left"
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      disabled={[
                        "actions",
                        "username",
                        "service",
                        "studio",
                        "company",
                      ].includes(column.id)}
                      active={valueToOrderBy === column.id}
                      direction={orderDirection}
                      onClick={() => handleRequestSort(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredItems?.map((pract) => {
              const isItemSelected = isSelected(pract.id);
              return (
                <TableRow
                  className="hover:shadow-md"
                  aria-checked={isItemSelected}
                  key={pract.id}
                  role="checkbox"
                  tabIndex={-1}
                  selected={isItemSelected}
                >
                  {/* <TableCell padding="checkbox">
                    <Checkbox
                      checked={isItemSelected}
                      onClick={(event) => event.stopPropagation()}
                      onChange={() => handleSelectSingleDoc(pract.id)}
                      inputProps={{ "aria-labelledby": pract.id }}
                    />
                  </TableCell> */}
                  <TableCell align="left" className="font-semibold w-2/12">
                    <div className="flex items-center">
                      {pract.name}
                      {pract.aiPromptId && <CoreIAicon />}
                      {pract.reservationId && (
                        <Tooltip title={t("Reservation")}>
                          <CalendarMonthRoundedIcon
                            className={`fill-blue-700 mx-1 w-5 h-5`}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="font-bold">
                    <CoreStatus status={pract.status} testo={true} />
                  </TableCell>

                  <TableCell align="left">
                    {" "}
                    {formatItalianDate(pract.createdAt)}
                  </TableCell>
                  <TableCell align="left">{pract.userName}</TableCell>

                  <TableCell align="left">{pract.fiscalCodeUser}</TableCell>
                  {appConfig?.modules?.company?.general && (
                    <TableCell align="left">
                      {pract.userCompanyName || "N/A"}
                    </TableCell>
                  )}
                  <TableCell align="left">{pract.commDisplayName}</TableCell>
                  <TableCell align="left">{pract.studio || "N/A"}</TableCell>
                  <TableCell align="left">{pract.service?.name}</TableCell>
                  <TableCell align="left">
                    {pract.expirationDate ? (
                      formatItalianDate(pract.expirationDate)
                    ) : (
                      <p className="italic">{t("NoOne")}</p>
                    )}
                  </TableCell>

                  <TableCell align="left" className="min-w-40">
                    <Tooltip title={t("Detail")}>
                      <IconButton
                        onClick={() =>
                          navigate(
                            `/auth/admin/${t("singlePracticeRoute")}/${
                              pract.id
                            }`,
                            {
                              state: pract.userId,
                            }
                          )
                        }
                        className="w-10 h-10"
                      >
                        <SearchRoundedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={`${t("Card")} ${t("user")}`}>
                      <IconButton
                        onClick={() => handleOpenUserCard(pract.userId)}
                        className="w-10 h-10 "
                      >
                        <AssignmentIndRoundedIcon />
                      </IconButton>
                    </Tooltip>
                    {!pract.adminId ? (
                      <Tooltip title={t("TakeCharge")}>
                        <IconButton
                          onClick={() => handleAdminPractices(pract)}
                          className="w-10 h-10"
                        >
                          <DoneRoundedIcon className="text-green-500" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title={t("RemoveTakeCharge")}>
                        <IconButton
                          onClick={() => handleRemoveAdminPractices(pract)}
                          className="w-10 h-10"
                        >
                          <CloseRoundedIcon className="text-red-600" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Divider />
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </TableContainer>

      <CoreModal
        component={
          <SchedaUtente handleClose={closeUserModal} userId={selectedUserId} />
        }
        state={isUserCardModalOpen}
        onClose={closeUserModal}
        width={"100%"}
        height={"100%"}
      />
    </div>
  );
};

export default GestionePraticheTable;
